import { connect } from "react-redux";
import MessageBody from "./MessageBody";

const mapState = ({ chats, users }) => ({
  messagesInView: chats.messagesInView,
  messagingUser: chats.messagingUser,
  myData: users.myData,
});
export default connect(mapState)(MessageBody);
